/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminMarketplaceType = {
    MarketplaceTypeFacebook: 'facebook',
    MarketplaceTypeEbay: 'ebay',
    MarketplaceTypeOfferUp: 'offer_up',
    MarketplaceTypeCraigsList: 'craigs_list',
    MarketplaceTypeMarcari: 'mercari',
    MarketplaceTypePoshmark: 'poshmark',
    MarketplaceTypeWalmart: 'walmart',
    MarketplaceTypeDepop: 'depop'
} as const;
export type AdminMarketplaceType = typeof AdminMarketplaceType[keyof typeof AdminMarketplaceType];


export function instanceOfAdminMarketplaceType(value: any): boolean {
    for (const key in AdminMarketplaceType) {
        if (Object.prototype.hasOwnProperty.call(AdminMarketplaceType, key)) {
            if (AdminMarketplaceType[key as keyof typeof AdminMarketplaceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminMarketplaceTypeFromJSON(json: any): AdminMarketplaceType {
    return AdminMarketplaceTypeFromJSONTyped(json, false);
}

export function AdminMarketplaceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketplaceType {
    return json as AdminMarketplaceType;
}

export function AdminMarketplaceTypeToJSON(value?: AdminMarketplaceType | null): any {
    return value as any;
}

export function AdminMarketplaceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminMarketplaceType {
    return value as AdminMarketplaceType;
}

